import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const getHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token}`, Accept: 'application/json' };
};

const projectWorkService = {
  /** Recupera project work del corso + stato del gruppo/consegna */
  async getProjectWork(courseId) {
    const res = await axios.get(`${API_BASE_URL}/project-work/course/${courseId}`, {
      headers: getHeaders(),
    });
    return res.data;
  },

  /** Lista gruppi disponibili per unirsi */
  async listGroups(courseId) {
    const res = await axios.get(`${API_BASE_URL}/project-work/course/${courseId}/groups`, {
      headers: getHeaders(),
    });
    return res.data;
  },

  /** Crea un nuovo gruppo */
  async createGroup(courseId, name) {
    const res = await axios.post(
      `${API_BASE_URL}/project-work/course/${courseId}/groups`,
      { name },
      { headers: getHeaders() }
    );
    return res.data;
  },

  /** Entra in un gruppo esistente */
  async joinGroup(groupId) {
    const res = await axios.post(
      `${API_BASE_URL}/project-work/groups/${groupId}/join`,
      {},
      { headers: getHeaders() }
    );
    return res.data;
  },

  /** Crea la repo GitHub per il gruppo (tipo IT) */
  async createGithubRepo(groupId) {
    const res = await axios.post(
      `${API_BASE_URL}/project-work/groups/${groupId}/github-repo`,
      {},
      { headers: getHeaders() }
    );
    return res.data;
  },

  async saveGithubUsername(githubUsername) {
    const res = await axios.post(
      `${API_BASE_URL}/user/github-username`,
      { github_username: githubUsername },
      { headers: getHeaders() }
    );
    return res.data;
  },

  /** Consegna il project work (file o conferma IT) */
  async submit(groupId, file = null, milestoneId = null, githubRepoUrl = null) {
    const formData = new FormData();
    if (file) formData.append('file', file);
    if (milestoneId) formData.append('milestone_id', milestoneId);
    if (githubRepoUrl) formData.append('github_repo_url', githubRepoUrl);

    const res = await axios.post(
      `${API_BASE_URL}/project-work/groups/${groupId}/submit`,
      file || milestoneId || githubRepoUrl ? formData : {},
      {
        headers: {
          ...getHeaders(),
          ...(file || milestoneId || githubRepoUrl ? { 'Content-Type': 'multipart/form-data' } : {}),
        },
      }
    );
    return res.data;
  },

  async confirmSubmission(submissionId) {
    const res = await axios.post(
      `${API_BASE_URL}/project-work/submissions/${submissionId}/confirm`,
      {},
      { headers: getHeaders() }
    );
    return res.data;
  },
};

export default projectWorkService;
